import React from "react";
import Enrolment from "../Enrolment";

const EnrolledPendingConfirmation = () => {
  return <Enrolment status="pending-confirmation" title="pending-confirmation" />;
};

export default EnrolledPendingConfirmation;
